// extracted by mini-css-extract-plugin
module.exports = {"loadingCourses":"Institutions_loadingCourses__1A8HO","noCourses":"Institutions_noCourses__3g7ae","courseCount":"Institutions_courseCount__1HYbO"};